<template>
  <div class="paydlg">
    <el-dialog v-model  = "innerVisible" width="604px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
        <div class="paydlg-panel" v-loading="loading"  element-loading-text="正在查询支付状态，请稍后......"  >
            <div class="tab-icon" @click="onClose">
               <i class="el-icon-close"></i>
            </div>
            <div class="tab-header">
               <div class="tab-btn separator" :class="{'active':payType==1}" @click="onSwitchPayType(1)">线上支付</div>
               <div class="tab-btn" :class="{'active':payType==2}" @click="onSwitchPayType(2)">线下支付</div>
            </div>

            <div class="tab-body tab-1" v-show="payType==1">
                <div class="qrcode" id="qrcode" ref="qrcode"></div>
                <div class="pay-option" :class="{'selected':payMode==1}">
                    <img class="option-icon" src="@assets/icon/vx.png" /> 微信支付
                    <img class="option-mark" v-if="payMode==1" src="@assets/icon/mark-true.png" />
                </div>
                <div class="confirm-btn-wrapper">
                    <div class="btn" @click="onConfirmPay">支付完成</div>
                </div>

            </div>

            <div class="tab-body tab-2" v-show="payType==2">
                <div class="tips">
                    <span> 您已选择线下支付方式，请在支付完成后联系订单销售代表进行确认 </span>
                </div>
                <div class="prop-panel">
                    <div class="prop-title">对公账号支付见下:</div>

                    <div class="prop"> <span class="label">账户名</span> <span class="value">{{ bankInfo.companyName}}</span> </div>
                    <div class="prop"> <span class="label">银行账号</span> <span class="value">{{ bankInfo.bankNo}}</span> </div>
                    <div class="prop"> <span class="label">开户银行</span> <span class="value">{{ bankInfo.bankName}}</span> </div>
                </div>
                <div class="upload-payvoucher-wrapper">
                    <upload v-model="payVoucher"></upload>
                    <div class="tips">请上传支付凭证，JPG/PNG/JPEG格式的图片，大小不超过5M</div>
                </div>
                <div class="confirm-btn-wrapper">
                    <div class="btn" @click="onConfirmPay" v-if="payVoucher">确认支付</div>
                    <div class="btn btn2" disabled v-else>确认支付</div>
                </div>
            </div>
        </div>

    </el-dialog>

    <!-- 支付成功对话框 -->
    <el-dialog
      v-model  = "successDialogVisible"
      width="604px"
      :show-close="false"
    >
      <div class="successTips">
        <img
          class="success-close-btn"
          src="@/assets/icon/close.png"
          @click="onPaymentSuccessClose"
        />
        <img src="@/assets/icon/成功状态.png" alt />
        订单支付成功
      </div>
    </el-dialog>

  </div>

</template>


<style lang="less" scope>

.paydlg{
    .paydlg-panel{
        position:relative;
        width:604px;
        height:560px;
        font-size:14px;

        .tab-icon{
            position:absolute;
            width:50px;
            height:50px;
            line-height:50px;
            text-align:center;
            right:0;
            top:0;
           
            /* background-color:#DEE; */
        }

        .tab-header{
            display:flex;
            align-items: center;
            justify-content: space-around;
            border-bottom: 1px solid #EEE;
            font-size:16px;
            .tab-btn{
                width:50%;
                height:50px;
                line-height:50px;
                text-align:center;
                cursor: pointer;
            }
            .separator{
                border-right:1px solid #EEE;
            }
            .active{
                color:#FF6A00;
                border-bottom: 2px solid #FF6A00;
            }
        }

        .tab-body{
            height:calc( 100% - 50px ); //100%继承paydlg-panel的高度 减去 tab-header高度,此处paydlg也可以使用flex布局，看移动端paydlg 实现样式

           .confirm-btn-wrapper{
                display:flex;
                justify-content:center;
                .btn{
                    color:#FFF;
                    width:140px;
                    height:28px;
                    line-height:28px;
                    text-align:center;
                    background-color:#FF6A00;
                    cursor: pointer;
                }
                .btn2{
                    background-color: rgb(201, 194, 194);
                    
                }
            }

        }

        .tab-1{
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;

            .qrcode{
                width:282px;
                height:282px;
                /* background-color:#EEE; */
            }
            
            .pay-option {
                margin:40px 0;
                border: 1px solid #EEE;
                color: #444;
                font-size: 16px;
                width: 270px;
                height: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                border-radius: 10px;

                .option-icon {
                    margin-right: 40px;
                }
                .option-mark {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
            }

            .selected {
                border: 1px solid #ff6a00;
            }
        }
        .tab-2{
            .tips{
                padding:20px;
                span{
                    color:#FF6A00;
                    padding:10px 40px;
                    background-color:#FFE1CC;
                }
            }
            .prop-panel{
                padding:0 20px;
                .prop-title{
                    color:#FF6A00;
                    padding:8px 0;
                }
                .prop{
                    display:flex;
                    color:rgba(68,68,68,0.8);
                    padding:8px 0;
                    .label{
                        width:100px;
                        text-align:right;
                    }
                    .value{
                        margin-left:40px;
                    }
                }
            }
            .upload-payvoucher-wrapper{
                padding:20px;
                display:flex;
                flex-direction:column;
                justify-content:center;
                align-items:center;

                .tips{
                    color:rgba(68,68,68,0.8);
                    padding:16px;
                    font-size:12px;
                }
            }
            
        }
    }

    .el-dialog__header {
        padding: 0;
    }
    .el-dialog__body{
        padding: 0;
    }

    .successTips {
        height: 202px;
        padding: 86px 230px;
        text-align: center;
        line-height: 30px;
        font-size: 24px;
        color: #27ae60;
        position: relative;
        > img {
            position: absolute;
            top: 88px;
            left: 200px;
        }
        .success-close-btn {
            position: absolute;
            top: 30px;
            left: 560px;
            z-index: 9999;
            cursor: pointer;
        }
    }
}

</style>

<script>      
import upload from '@components/Upload'
import QRCode from "qrcodejs2";
import {qrcodePay,getPayBankInfo,offlinePay,pollingPayResult} from '@api/pay.js'
export default {
    inject:['reload'],
  props: {
      visible: {
          type: Boolean,
          default: false
      },
      orderNumber:''
  },
  components: {
    upload
  },
  data(){
      return {
          innerVisible: this.visible,
          payType:1,
          payMode:1,
          loading:false,

          bankInfo:{
              companyName:"",
              bankNo:"",
              bankName:""
          },
          codeUrl:'',
          qrcode:null,
          payVoucher:'',

          //   支付成功对话框
          successDialogVisible: false,
      }
  },
  watch: {
      visible(newVal) {
          this.innerVisible = newVal
          if(this.innerVisible){
              //想想为啥这块调用nexttick，想想qrcodePay已经是异步的话，还需要nexttick吗？
              this.$nextTick(()=>{
                  qrcodePay({orderNumber:this.orderNumber,payMode:1,payType:1}).then(res=>{
                      this.codeUrl=res.data.code_url
                      this.makeQR()
                  })
              })
          }
      },
      innerVisible(newVal) {
          this.$emit('update:visible', newVal)
      }
  },
  methods:{
    onSwitchPayType(v) {
      this.payType = v
    },
    onClose(){
        this.payVoucher = ''
        this.innerVisible=false
        this.loading=false
        if(this.timer)clearInterval(this.timer)
    },
    makeQR() {
        if(this.qrcode){
            this.qrcode.clear()
            this.qrcode.makeCode(this.codeUrl)
        }else{
            this.qrcode = new QRCode("qrcode", {
                text: this.codeUrl, // 需要转换为二维码的内容
                width: 282,
                height: 282,
                colorDark: "#000000",
                colorLight: "#ffffff",
                // correctLevel: QRCode.CorrectLevel.H
            })
        }
    },
    onConfirmPay(){
        if(this.payType==1){

            this.$confirm('请确认是否已完成扫码支付?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let count=0
                this.loading=true
                this.timer && clearInterval(this.timer)
                const timerFunc=()=>{
                    count++
                    
                    pollingPayResult(this.orderNumber).then(res=>{
                        if(res.data.payState==1){
                            this.$emit('pay-success')
                            this.onClose()
                            this.successDialogVisible=true
                        }else{
                            if(count>=30){
                                this.$message.error("支付超时，请重新尝试！") 
                                this.onClose()
                            }
                        }
                    }).catch(err=>{
                        this.onClose()
                    })
                }
                //下面传入函数调用一次是想立即执行,否则定时器会等1000毫秒后才执行第一次
            timerFunc()
            this.timer=setInterval(timerFunc, 2000);


            }).catch(() => {
            })
            
        }
        if(this.payType==2){

             if(this.payVoucher){ 
                offlinePay({orderNumber:this.orderNumber,payVoucher:this.payVoucher}).then(res=>{
                    this.$emit('pay-success')
                    this.onClose()
                    this.successDialogVisible=true
                })
             }else{ 
                 this.$message.error("请先上传支付凭证！") 
             } 
        }
    },
    onPaymentSuccessClose() {
      this.successDialogVisible = false;
      this.reload()
    },
  },
  mounted(){
      getPayBankInfo().then(res=>{
          this.bankInfo=res.data
      })
  }
}

</script>

